/** Server polling can replace the array while a meeting editor is open. */
export function currentMeeting<T extends {id: string}>(items: T[], selected: T): T | undefined {
  return items.find(item => item.id === selected.id);
}
